const StrangeAuth = require("strange-auth");
const AuthTypes = require("action-types/auth");
const CheckoutTypes = require("action-types/checkout");
const Deeply = require("utils/deeply");

const internals = {};

const strangeReducer = StrangeAuth.makeReducer();

module.exports = (state, action) => {
    state = strangeReducer(state, action);

    const { payload, type } = action;

    switch (type) {
        case AuthTypes.USER_FETCH_SUCCESS:
            return Deeply(state)
                .set("credentials.user", payload.user)
                .value();

        case AuthTypes.UPDATE_EMAIL_SUCCESS:
            return Deeply(state)
                .set("credentials.user.email", payload.email)
                .value();

        case CheckoutTypes.PURCHASE_OPTION_SUCCESS:
            return Deeply(state)
                .set(
                    "credentials.user.credits",
                    state.credentials.user.credits +
                        payload.payment.paymentOption.numCredits
                )
                .value();
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js